import {find, get, has} from 'lodash'
import {getUser} from 'selectors/auth'
import {isSystemNotification, isUserNotification} from 'helpers/notifications'

export const getNotifications = (state) => get(state, 'notifications.notifications') || []

export const getUserNotifications = (state) => {
  const user = getUser(state)
  return getNotifications(state).filter(n => isUserNotification(user, n))
}

export const getSystemNotifications = (state) => {
  const user = getUser(state)
  return getNotifications(state).filter(n => isSystemNotification(user, n))
}

export const getUserNotificationById = (state, id) => {
  id = has(id, 'id') ? id.id : id
  const userNotifications = getUserNotifications(state)
  return find(userNotifications, notification => notification.id === id)
}

export const getHiddenNotifications = (state) => state.notifications.hidden || []
